(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/set-deposit-limits-form-dropdown.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/set-deposit-limits-form-dropdown.js');
'use strict';

const {
  logger
} = svs.accountservicesReact;
const {
  useState,
  useEffect,
  Fragment
} = React;
const {
  useHistory
} = ReactRouterDOM;
const {
  Form,
  ControlGroup
} = svs.ui.reactForm;
const {
  GridRow,
  GridCol
} = svs.ui.ReactGrid;
const {
  Currency: formatCurrency
} = svs.utils.format;
const {
  DateForLimitUpdate
} = svs.accountservicesReact.gameLimitDepositsForm;
const DepositLimitDropdown = svs.accountservicesReact.gameLimitDepositsForm.DepositLimitDropdown;
const AmountInput = svs.ui.reactFormInputs.AmountInput;
const Button = svs.ui.ReactButton;
const service = svs.accountservicesReact.gameLimitDepositsForm.maxLimitsService;
const initMaxRange = (isUnderTwenty, isTwentyToTwentyFive) => {
  if (svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE)) {
    return 1000000;
  }
  if (isUnderTwenty) {
    return 1000;
  }
  if (isTwentyToTwentyFive) {
    return 5000;
  }
  return 10000;
};
const SetDepositLimitsFormDropdown = _ref => {
  let {
    allDepositLimits,
    isUnderTwenty,
    isTwentyToTwentyFive,
    hasNewlyUpdatedDepositLimits,
    isChangeLimitsForm,
    costOfGame,
    currentDayDepositBudget,
    currentWeekDepositBudget,
    currentMonthDepositBudget,
    dayLimit,
    futureDayDepositBudget,
    futureMonthDepositBudget,
    futureWeekDepositBudget,
    infoMessage,
    monthLimit,
    setDayLimit,
    onDone,
    setMonthLimit,
    setWeekLimit,
    warningMessage,
    weekLimit
  } = _ref;
  const history = useHistory();
  const [fieldLimitErrors, setFieldLimitErrors] = useState({});
  const [formValidationErrors, setFormValidationErrors] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [maxRange, setMaxRange] = useState(initMaxRange(isUnderTwenty, isTwentyToTwentyFive));
  const [maxValueDay, setMaxValueDay] = useState(parseInt(maxRange, 10));
  const [isNoChanges, setIsNoChanges] = useState(false);
  const [displayInputFieldMonth, setDisplayInputFieldMonth] = useState(false);
  const [displayInputFieldWeek, setDisplayInputFieldWeek] = useState(false);
  const [displayInputFieldDay, setDisplayInputFieldDay] = useState(false);
  const [isNotSelectedMonthAmount, setIsNotSelectedMonthAmount] = useState(false);
  const [isNotSelectedWeekAmount, setIsNotSelectedWeekAmount] = useState(false);
  const [isNotSelectedDayAmount, setIsNotSelectedDayAmount] = useState(false);
  const minRange = 25;
  useEffect(() => {
    (async () => {
      const {
        data,
        error
      } = await service.getGamblingCareSpendLimitInfoAsync();
      if (error) {
        logger.warn('Error getting gambling care spend limit info:', error);
        return;
      }
      const maxLimit = data === null || data === void 0 ? void 0 : data.spendLimit;
      if (maxLimit) {
        setMaxRange(parseInt(maxLimit, 10));
      }
    })();
  }, []);

  useEffect(() => {
    const values = [monthLimit, weekLimit, maxRange];
    const filteredValues = values.filter(value => value > minRange);
    setMaxValueDay(Math.min(...filteredValues));
  }, [monthLimit, weekLimit, maxRange, minRange]);


  const isNumeric = str => {
    if (typeof str != 'string') {
      return false;
    }
    return !isNaN(str) && !isNaN(parseFloat(str)); 
  };

  const validateAllAmountFormattings = () => !isNumeric(dayLimit) || !isNumeric(weekLimit) || !isNumeric(monthLimit);

  const parseFloatOrZero = value => parseFloat(value) || 0;
  const validateDropdowns = () => {
    if (!monthLimit) {
      setIsNotSelectedMonthAmount(true);
    }
    if (!weekLimit) {
      setIsNotSelectedWeekAmount(true);
    }
    if (!dayLimit) {
      setIsNotSelectedDayAmount(true);
    }
  };

  const validateAllLimitSizes = () => {
    const newErrorObject = {};
    const dayLimitNumber = parseFloatOrZero(dayLimit);
    const weekLimitNumber = parseFloatOrZero(weekLimit);
    const monthLimitNumber = parseFloatOrZero(monthLimit);
    if (weekLimitNumber > monthLimitNumber) {
      newErrorObject.weekLimit = 'Din veckogräns kan inte vara högre än din månadsgräns.';
    }
    if (dayLimitNumber > weekLimitNumber && dayLimitNumber > monthLimitNumber) {
      newErrorObject.dayLimit = 'Din dagsgräns kan inte vara högre än din månads- och veckogräns.';
    } else {
      if (dayLimitNumber > monthLimitNumber) {
        newErrorObject.dayLimit = 'Din dagsgräns kan inte vara högre än din månadsgräns.';
      }
      if (dayLimitNumber > weekLimitNumber) {
        newErrorObject.dayLimit = 'Din dagsgräns kan inte vara högre än din veckogräns.';
      }
    }
    setFieldLimitErrors(newErrorObject);
    return Boolean(Object.keys(newErrorObject).length);
  };

  const onValidateHandler = (name, isValid, errorMessage) => {
    if (!isValid) {
      const filteredErrors = [...formValidationErrors.filter(err => err.id !== name)];
      setFormValidationErrors([...filteredErrors, {
        id: name,
        error: errorMessage
      }]);
    } else {
      setFormValidationErrors(formValidationErrors.filter(err => err.id !== name));
    }
  };
  const isValidRange = () => parseFloat(dayLimit) >= minRange && parseFloat(dayLimit) <= maxRange && parseFloat(weekLimit) >= minRange && parseFloat(weekLimit) <= maxRange && parseFloat(monthLimit) >= minRange && parseFloat(monthLimit) <= maxRange;
  const onSubmitHandler = async (e, formData) => {
    e.preventDefault();
    const parsedDayLimit = parseInt(dayLimit, 10);
    const parsedWeekLimit = parseInt(weekLimit, 10);
    const parsedMonthLimit = parseInt(monthLimit, 10);
    if (isChangeLimitsForm && (parsedMonthLimit === currentMonthDepositBudget || parsedMonthLimit === futureMonthDepositBudget) && (parsedWeekLimit === currentWeekDepositBudget || parsedWeekLimit === futureWeekDepositBudget) && (parsedDayLimit === currentDayDepositBudget || parsedDayLimit === futureDayDepositBudget)) {
      setIsNoChanges(true);
      return;
    }
    const hasNoChoosenValues = validateDropdowns();
    if (hasNoChoosenValues) {
      return;
    }
    if (formValidationErrors.length) {
      logger.debug('has form validation errors: ', formValidationErrors);
      return;
    }
    const hasFormattingErrors = validateAllAmountFormattings();
    if (hasFormattingErrors) {
      logger.debug('has formatting errors: ', hasFormattingErrors);
      return;
    }
    const hasLimitErrors = validateAllLimitSizes();
    if (hasLimitErrors) {
      logger.debug('has limit errors:', hasLimitErrors);
      return;
    }
    const hasValidRange = isValidRange();
    if (!hasValidRange) {
      return;
    }
    if (isButtonDisabled) {
      return;
    }
    setIsButtonDisabled(true);
    if (isChangeLimitsForm) {
      onDone(e, formData);
    } else {
      onDone(!displayInputFieldMonth, !displayInputFieldWeek, !displayInputFieldDay);
    }
    setIsButtonDisabled(false);
  };
  const errorMessageMin = () => "Den l\xE4gsta gr\xE4nsen du kan s\xE4tta \xE4r ".concat(formatCurrency(minRange), " kr.");
  const errorMessageMax = () => "Du kan inte ha en h\xF6gre gr\xE4ns \xE4n ".concat(formatCurrency(maxRange), " kr.");
  return React.createElement(Form, {
    className: "margin-h-0 align-left",
    onSubmit: onSubmitHandler,
    onValidate: onValidateHandler,
    setError: fieldLimitErrors
  }, React.createElement(ControlGroup, {
    isLessSpace: true,
    v2: true
  }, React.createElement(DepositLimitDropdown, {
    costOfGame: costOfGame,
    errorMessageRequired: "Du m\xE5ste ange m\xE5nadsgr\xE4ns",
    hasErrorRequired: isNotSelectedMonthAmount && !monthLimit && !displayInputFieldMonth,
    maxValue: parseInt(maxRange, 10),
    minValue: parseInt(weekLimit, 10),
    onSelect: chosenValue => {
      if (chosenValue === 'Månadsgräns') {
        return setDisplayInputFieldMonth(false);
      }
      if (chosenValue === 'own-amount') {
        return setDisplayInputFieldMonth(true);
      }
      setMonthLimit(chosenValue.toString());
      setDisplayInputFieldMonth(false);
    },
    period: "M\xE5nadsgr\xE4ns"
  }), displayInputFieldMonth === true && React.createElement(AmountInput, {
    errorMessageDefault: "Ange beloppet med hela siffror.",
    errorMessageMax: errorMessageMax(),
    errorMessageMin: errorMessageMin(),
    errorMessageRequired: "Du m\xE5ste ange m\xE5nadsgr\xE4ns",
    isLessSpace: true,
    label: "M\xE5nadsgr\xE4ns",
    max: maxRange,
    min: minRange,
    name: "monthLimit",
    onChange: e => {
      setMonthLimit(e.target.value);
      setIsNoChanges(false);
    },
    placeholder: "Skriv beloppet i kronor",
    value: monthLimit
  })), React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(DepositLimitDropdown, {
    costOfGame: costOfGame,
    errorMessage: !displayInputFieldWeek ? fieldLimitErrors.weekLimit : undefined,
    errorMessageRequired: "Du m\xE5ste ange veckogr\xE4ns",
    hasErrorRequired: isNotSelectedWeekAmount && !weekLimit && !displayInputFieldWeek,
    id: "week-dropdown",
    maxValue: monthLimit ? parseInt(monthLimit, 10) : parseInt(maxRange, 10),
    minValue: parseInt(dayLimit, 10),
    onSelect: chosenValue => {
      if (chosenValue === 'Veckogräns') {
        return setDisplayInputFieldWeek(false);
      }
      if (chosenValue === 'own-amount') {
        return setDisplayInputFieldWeek(true);
      }
      setWeekLimit(chosenValue.toString());
      setDisplayInputFieldWeek(false);
    },
    period: "Veckogr\xE4ns"
  }), displayInputFieldWeek && React.createElement(AmountInput, {
    errorMessageDefault: "Ange beloppet med hela siffror.",
    errorMessageMax: errorMessageMax(),
    errorMessageMin: errorMessageMin(),
    errorMessageRequired: "Du m\xE5ste ange veckogr\xE4ns",
    isLessSpace: true,
    label: "Veckogr\xE4ns",
    max: maxRange,
    min: minRange,
    name: "weekLimit",
    onChange: e => {
      setWeekLimit(e.target.value);
      setIsNoChanges(false);
    },
    placeholder: "Skriv beloppet i kronor",
    value: weekLimit
  })), React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(DepositLimitDropdown, {
    costOfGame: costOfGame,
    errorMessage: !displayInputFieldDay ? fieldLimitErrors.dayLimit : undefined,
    errorMessageRequired: "Du m\xE5ste ange dagsgr\xE4ns",
    hasErrorRequired: isNotSelectedDayAmount && !dayLimit && !displayInputFieldDay,
    id: "day-dropdown",
    maxValue: maxValueDay,
    onSelect: chosenValue => {
      if (chosenValue === 'Dagsgräns') {
        return setDisplayInputFieldDay(false);
      }
      if (chosenValue === 'own-amount') {
        return setDisplayInputFieldDay(true);
      }
      setDayLimit(chosenValue.toString());
      setDisplayInputFieldDay(false);
    },
    period: "Dagsgr\xE4ns"
  }), displayInputFieldDay && React.createElement(AmountInput, {
    errorMessageDefault: "Ange beloppet med hela siffror.",
    errorMessageMax: errorMessageMax(),
    errorMessageMin: errorMessageMin(),
    errorMessageRequired: "Du m\xE5ste ange dagsgr\xE4ns",
    isLessSpace: true,
    label: "Dagsgr\xE4ns",
    max: maxRange,
    min: minRange,
    name: "dayLimit",
    onChange: e => {
      setDayLimit(e.target.value);
      setIsNoChanges(false);
    },
    placeholder: "Skriv beloppet i kronor",
    value: dayLimit
  })), infoMessage && React.createElement("div", {
    className: "margin-top-2"
  }, infoMessage), warningMessage && React.createElement("div", {
    className: "margin-top-2"
  }, warningMessage), isChangeLimitsForm ? React.createElement(Fragment, null, allDepositLimits && React.createElement(DateForLimitUpdate, {
    allLimits: allDepositLimits,
    hasMarginTop: true,
    isNewlyUpdatedLimits: hasNewlyUpdatedDepositLimits
  }), isNoChanges && React.createElement("p", {
    className: "margin-top-2"
  }, "Det finns inga nya gr\xE4nser att spara."), React.createElement("div", {
    className: "margin-top-2 margin-bottom-1"
  }, React.createElement(GridRow, {
    md: {
      gutter: 1
    },
    xs: {
      gutter: 1
    }
  }, React.createElement(GridCol, {
    md: 6,
    xs: 6
  }, React.createElement(Button, {
    block: true,
    onClick: () => history.push('/'),
    transparent: true,
    type: "button"
  }, "Tillbaka")), React.createElement(GridCol, {
    md: 6,
    xs: 6
  }, React.createElement(Button, {
    block: true,
    id: "depositLimitSubmit",
    inverted: true,
    type: "submit"
  }, "Spara \xE4ndringar"))))) : React.createElement(Button, {
    block: true,
    className: "margin-top-2 margin-bottom-1",
    disabled: isButtonDisabled,
    focus: true,
    type: "submit"
  }, "Forts\xE4tt"));
};
svs.accountservicesReact.gameLimitDepositsForm.SetDepositLimitsFormDropdown = SetDepositLimitsFormDropdown;

 })(window);